import { cn } from '@/lib/utils'
import { LottieLoading } from './loading-lottie'

export function SplashScreen({
  fadingOut = false,
  onComplete,
}: {
  fadingOut?: boolean
  onComplete?: () => void
}) {
  return (
    <div
      className={cn(
        'fixed inset-0 z-99 flex items-center justify-center overflow-hidden',
        'bg-background transition-opacity duration-700 ease-in-out',
        fadingOut ? 'pointer-events-none opacity-0' : 'opacity-100'
      )}
    >
      {/* 1. 流光背景层 - 保持不变，作为氛围底色 */}
      <div className='absolute inset-0 -z-10 overflow-hidden'>
        {/* 主要流光点 1: Primary 暖色 */}
        <div
          className='animate-mesh absolute -top-[20%] -left-[10%] h-[70%] w-[70%] rounded-full opacity-40 dark:opacity-25'
          style={{
            background:
              'radial-gradient(circle, var(--primary) 0%, transparent 75%)',
            filter: 'blur(80px)',
          }}
        />

        {/* 辅助流光点 2: Chart-1 冷色 */}
        <div
          className='animate-mesh absolute -right-[10%] -bottom-[10%] h-[60%] w-[60%] opacity-35 dark:opacity-20'
          style={{
            background:
              'radial-gradient(circle, var(--chart-1) 0%, transparent 75%)',
            filter: 'blur(100px)',
            animationDelay: '-5s',
          }}
        />

        {/* 辅助流光点 3: Accent 补充色 */}
        <div
          className='animate-mesh absolute top-[30%] left-[20%] h-[50%] w-[50%] opacity-25 dark:opacity-15'
          style={{
            background:
              'radial-gradient(circle, var(--accent) 0%, transparent 75%)',
            filter: 'blur(120px)',
            animationDelay: '-10s',
          }}
        />
      </div>

      {/* 2. 动画内容区 - 去掉了背景色、边框、投影和毛玻璃效果 */}
      <div
        className={cn(
          'relative z-10 flex flex-col items-center justify-center',
          'transition-all duration-700 ease-out',
          fadingOut ? 'scale-110 opacity-0 blur-sm' : 'scale-100 opacity-100'
        )}
      >
        <div className='w-[min(240px,60vw)] sm:w-[280px] md:w-[320px]'>
          <LottieLoading loop={false} autoplay onComplete={onComplete} />
        </div>

        {/* 可选：如果你想加一点极简的文字提示，可以在这里添加，否则直接删除下行 */}
        {/* <p className="mt-4 text-sm font-medium tracking-widest text-foreground/40 animate-pulse">LOADING</p> */}
      </div>
    </div>
  )
}
